import { Component, Input } from '@angular/core';
import { MenuParentNode, MenuNode } from '../menu-nav-bar.model';

@Component({
    selector: 'menu-search',
    templateUrl: './menu-search.component.html',
    styleUrls: ['./menu-search.component.scss'],
    standalone: false
})
export class MenuSearchComponent {

  public searchKeyWord = '';
  public numOfItems: number;
  @Input('nodes') nodes: Array<MenuNode | MenuParentNode>;

  public search(menies: Array<MenuNode | MenuParentNode> = this.nodes) {
    this.removeAllHighLights();
    this.collapseAllMenuParentNodes();
    this.numOfItems = 0;
    if (this.searchKeyWord !== '' && this.searchKeyWord !== ' ') {
      for (const menu of menies) {
        if (menu.isVisible) {
          if (this.containsSearchWord(menu)) {
            menu.label = this.highlightMenuNodeLabel(menu);
            this.numOfItems++;
          }
          if ('children' in menu && menu.children) {
            for (const child of menu.children) {
              if (this.containsSearchWord(child) && child.isVisible) {
                menu.isCollapsed = false;
                child.label = this.highlightMenuNodeLabel(child);
                this.numOfItems++;
              }
            }
          }
        }
      }
    }
  }

  public collapseAllMenuParentNodes() {
    for (const menu of this.nodes) {
      if('isCollapsed' in menu) {
        menu.isCollapsed = true;
      }
    }
  }

  public containsSearchWord(menuNode: MenuNode): boolean {
    if ((menuNode.label.toLowerCase()).indexOf(this.searchKeyWord.toLowerCase()) !== -1) {
      return true;
    }
    return false;
  }

  public highlightMenuNodeLabel(menuNode: MenuNode): string {
    return menuNode.label.replace(new RegExp(this.searchKeyWord, 'gi'), '<span class="highlight">$&</span>');
  }

  public removeHighlights(menuNode: MenuNode): string {
    menuNode.label = menuNode.label.replace(new RegExp('<span class="highlight">', 'g'), '');
    menuNode.label = menuNode.label.replace(new RegExp('</span>', 'g'), '');
    return menuNode.label;
  }

  public removeAllHighLights(menies: Array<MenuNode | MenuParentNode> = this.nodes) {
    for (const menu of menies) {
      this.removeHighlights(menu);
      if ("children" in menu && menu.children) {
        for (const child of menu.children) {
          this.removeHighlights(child);
        }
      }
    }
  }

  resetMenuSearch() {
    this.searchKeyWord = '';
    this.numOfItems = 0;
    this.removeAllHighLights();
    this.collapseAllMenuParentNodes();
  }

  constructor() { }
}
